import React from 'react'
import { FormattedMessage } from 'react-intl'

export default class EmailValidator {
  constructor({ value }) {
    this.pattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/g
    this.errorMessage = <FormattedMessage id="invalid_email" />
    this.value = value
  }

  validate() {
    if (!this.pattern.test(this.value)) {
      return this.errorMessage
    }

    return null
  }
}
